import {
    Avatar,
    Card,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    styled,
    Typography,
} from '@mui/material';
import { format, parseISO } from 'date-fns';
import SaveCalendar from '../Calendar/SaveCalender';

const RootGrid = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
}));

const BookingCard = styled(Card)(({ theme }) => ({
    paddingTop: '12px',
    marginRight: '12px',
    height: '100%',
    [theme.breakpoints.down('md')]: {
        marginRight: '0px',
    },
}));

const GridBorder = styled(Grid)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        marginBottom: '20px',
        'padding-bottom': '20px',
    },
}));

export const BookingSubDetails = props => {
    return (
        <>
            <GridBorder item xs={12} md={6}>
                <BookingCard>
                    {/* Seperate into booking details */}
                    <RootGrid container xs={12}>
                        <Grid item xs={12} sm={3} md={5}>
                            <Typography variant="h6">Booking Date:</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={5}>
                            <Typography
                                variant="h5"
                                display="inline"
                                sx={{ marginLeft: 2 }}
                            >
                                {format(
                                    parseISO(props.booking.startDate),
                                    'dd MMM YYY'
                                )}
                            </Typography>
                        </Grid>
                    </RootGrid>
                    <RootGrid container xs={12}>
                        <Grid item xs={12} sm={3} md={5}>
                            <Typography variant="h6">Start Time:</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={5}>
                            <Typography
                                variant="h5"
                                display="inline"
                                sx={{ marginLeft: 2 }}
                            >
                                {format(
                                    parseISO(props.booking.startDate),
                                    'h:mma'
                                )}
                            </Typography>
                        </Grid>
                    </RootGrid>
                    <RootGrid container xs={12}>
                        <Grid item xs={12} sm={3} md={5}>
                            <Typography variant="h6">End Time:</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={5}>
                            <Typography variant="h5" sx={{ marginLeft: 2 }}>
                                {format(
                                    parseISO(props.booking.endDate),
                                    'h:mma'
                                )}
                            </Typography>
                        </Grid>
                    </RootGrid>
                    {typeof props.booking.grade !== 'undefined' && (
                        <RootGrid container xs={12}>
                            <Grid item xs={12} sm={3} md={5}>
                                <Typography variant="h6">
                                    {props.booking.grade.length === 1
                                        ? 'Grade:'
                                        : 'Grades:'}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={5}>
                                <List sx={{ paddingTop: 0 }}>
                                    {props.booking.grade.length > 0 &&
                                        props.booking.grade.map(gradeItem => (
                                            <ListItem sx={{ paddingTop: 0 }}>
                                                <ListItemText
                                                    id={gradeItem}
                                                    primary={gradeItem}
                                                />
                                            </ListItem>
                                        ))}
                                </List>
                            </Grid>
                        </RootGrid>
                    )}
                    {typeof props.booking.fillTeacher !== 'undefined' && (
                        <RootGrid container xs={12}>
                            <Grid item xs={12} sm={3} md={5}>
                                <Typography variant="h6">
                                    {props.booking.fillTeacher.length === 1
                                        ? 'Classroom Teacher:'
                                        : 'Classroom Teachers:'}
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} md={5}>
                                <List
                                    dense
                                    sx={{
                                        width: '100%',
                                        maxWidth: 360,
                                        bgcolor: 'background.paper',
                                    }}
                                >
                                    {props.booking.fillTeacher.map(person => {
                                        return (
                                            <ListItemButton>
                                                <ListItem
                                                    key={person.teacherId}
                                                    disablePadding
                                                >
                                                    <ListItemAvatar>
                                                        <Avatar
                                                            alt={
                                                                person.teacherFirstName +
                                                                ' ' +
                                                                person.teacherLastName
                                                            }
                                                            src={
                                                                person.profileImage
                                                            }
                                                        />
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        id={
                                                            person.teacherId +
                                                            '1'
                                                        }
                                                        primary={
                                                            person.teacherFirstName +
                                                            ' ' +
                                                            person.teacherLastName
                                                        }
                                                    />
                                                </ListItem>
                                            </ListItemButton>
                                        );
                                    })}
                                </List>

                                {/* {props.booking.fillTeacher.map(person => {
                                return (
                                    <Chip
                                        sx={{ m: 0.5 }}
                                        avatar={
                                            <Avatar
                                                alt={
                                                    person.teacherFirstName +
                                                    ' ' +
                                                    person.teacherLastName
                                                }
                                                src={person.profileImage}
                                            />
                                        }
                                        label={
                                            person.teacherFirstName +
                                            ' ' +
                                            person.teacherLastName
                                        }
                                        variant="outlined"
                                    />
                                );
                            })} */}

                                {/* <ul>
                                {props.booking.fillTeacher.map(person => {
                                    return (
                                        <li>
                                            {person.teacherFirstName +
                                                ' ' +
                                                person.teacherLastName}
                                        </li>
                                    );
                                })}
                            </ul> */}
                                {/* <Typography variant="h5">
                                                {state.booking
                                                    .fillTeacherFirstName +
                                                    ' ' +
                                                    state.booking
                                                        .fillTeacherLastName}
                                            </Typography> */}
                            </Grid>
                        </RootGrid>
                    )}
                </BookingCard>
            </GridBorder>
            {props.teacher && props.booking.status === 'Approved' && (
                <GridBorder xs={12} md={6}>
                    <BookingCard>
                        <SaveCalendar booking={props.booking} />
                    </BookingCard>
                </GridBorder>
            )}
        </>
    );
};

export default BookingSubDetails;
